import React from 'react';
import { CarIcon, TruckIcon, CpuIcon, ArmchairIcon, ArrowRightIcon } from 'lucide-react';
import { Card } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
export function ServicesGrid() {
  const services = [{
    icon: CarIcon,
    title: 'Autos y Flotillas',
    description: 'Vehículos nuevos y seminuevos para tu empresa. Ideal para flotillas corporativas.',
    benefits: ['100% deducible', 'Seguros incluidos', 'Mantenimiento opcional'],
    plazo: '24 a 48 meses',
    color: 'bg-blue-100 text-blue-600'
  }, {
    icon: TruckIcon,
    title: 'Transporte y Maquinaria',
    description: 'Camiones, tractocamiones y maquinaria pesada para construcción e industria.',
    benefits: ['Sin descapitalización', 'Renovación constante', 'Deducción inmediata'],
    plazo: '36 a 60 meses',
    color: 'bg-orange-100 text-orange-600'
  }, {
    icon: CpuIcon,
    title: 'Equipo de Cómputo',
    description: 'Laptops, servidores, equipos de red y tecnología para tu operación.',
    benefits: ['Actualización continua', 'Soporte técnico', 'Escalable'],
    plazo: '12 a 36 meses',
    color: 'bg-purple-100 text-purple-600'
  }, {
    icon: ArmchairIcon,
    title: 'Mobiliario y Oficina',
    description: 'Muebles, equipo de oficina y activos para espacios de trabajo.',
    benefits: ['Diseño profesional', 'Flexibilidad', 'Deducible al 100%'],
    plazo: '24 a 48 meses',
    color: 'bg-green-100 text-green-600'
  }];
  return <section id="soluciones" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50" data-id="element-247">
      <div className="max-w-7xl mx-auto" data-id="element-248">
        <div className="text-center mb-12" data-id="element-249">
          <Badge variant="primary" className="mb-4" data-id="element-250">
            Soluciones
          </Badge>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-251">
            ¿Qué puedes arrendar?
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-252">
            Financiamos los activos que tu negocio necesita para crecer
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-253">
          {services.map((service, index) => <Card key={index} hover data-id="element-254">
              <div className="flex items-start gap-4" data-id="element-255">
                <div className={`flex-shrink-0 w-14 h-14 ${service.color} rounded-xl flex items-center justify-center`} data-id="element-256">
                  <service.icon className="w-7 h-7" data-id="element-257" />
                </div>
                <div className="flex-1" data-id="element-258">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-259">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 mb-4" data-id="element-260">{service.description}</p>

                  <div className="space-y-2 mb-4" data-id="element-261">
                    {service.benefits.map((benefit, idx) => <div key={idx} className="flex items-center gap-2 text-sm text-slate-700" data-id="element-262">
                        <svg className="w-4 h-4 text-success flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" data-id="element-263">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-264" />
                        </svg>
                        {benefit}
                      </div>)}
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-slate-200" data-id="element-265">
                    <span className="text-sm text-slate-600" data-id="element-266">
                      Plazo:{' '}
                      <span className="font-semibold text-slate-900" data-id="element-267">
                        {service.plazo}
                      </span>
                    </span>
                    <button className="text-primary font-semibold text-sm hover:text-primary-dark transition-colors inline-flex items-center gap-1" data-id="element-268">
                      Cotizar
                      <ArrowRightIcon className="w-4 h-4" data-id="element-269" />
                    </button>
                  </div>
                </div>
              </div>
            </Card>)}
        </div>

        <div className="mt-12 text-center" data-id="element-270">
          <Card className="inline-block" data-id="element-271">
            <div className="flex items-center gap-4" data-id="element-272">
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center" data-id="element-273">
                <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-274">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-275" />
                </svg>
              </div>
              <div className="text-left" data-id="element-276">
                <h4 className="font-bold text-slate-900" data-id="element-277">Sale & Lease Back</h4>
                <p className="text-sm text-slate-600" data-id="element-278">
                  Libera liquidez de tus activos existentes
                </p>
              </div>
              <Button variant="outline" size="sm" data-id="element-279">
                Conocer más
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}